var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert',{attrs:{"title":_vm.notification.title,"message":_vm.notification.message,"type":_vm.notification.status,"dismissible":""},on:{"close":_vm.deleteNotification}})
}
var staticRenderFns = []

export { render, staticRenderFns }